import React from 'react';
import Geography from "./Geography";
import Management from "./Management";
import {connect} from "react-redux";
import {setGeoChoice} from "../../../actions/CreateSiteActions/dimensionActions";
import {ChoiceGroup} from '@fluentui/react';
import InfoTooltip from '../../formFields/InfoTooltip';
import Warning from "../CommonComponents/Warning";
import { getUserManager } from '../../../actions/userActions';
import { addElement } from '../../../actions/CreateSiteActions/createSiteActions';
import { ADD_OWNER } from '../../../actions/types';

const CROSS_ORGANIZATION = { key:'Cross', value: 'Cross Organisation' };

class CombineSteps extends React.Component {

    constructor() {
        super();
        this.state= {crossOrganisation : null}
    }

    componentDidMount(): void {
        if ((this.props.selectedGeo && this.props.selectedGeo.key === CROSS_ORGANIZATION.key)
            || (this.props.geographyConfig.defaultKey && this.props.geographyConfig.defaultKey === CROSS_ORGANIZATION.key)) {
                
            this.setState({crossOrganisation: true});
            this.props.setGeography(CROSS_ORGANIZATION);
        }
        else if (this.props.selectedGeo 
            || (this.props.geographyConfig.defaultKey && this.props.geographyConfig.defaultKey !== CROSS_ORGANIZATION.key)
            || this.props.geographyConfig.isCrossOrgDisabled) {
            this.setState({crossOrganisation: false});
        }
        
        this._initializeOwner();
    }

    _initializeOwner() {
        const owner = this.props.currentUser;
        if(!this.props.owner && owner) {
            this.props.addOwner(owner);
            this.props.getUserManager(owner.id);
        }
    }

    isCountryRegionOrganization() {
        return this.state.crossOrganisation === false;
    }

    isCrossOrganization() {
        return this.state.crossOrganisation;
    }

    onCrossOrganizationSelect = (e, option) => {
        this.setState({crossOrganisation: option.key});
        this.props.setGeography(option.key ? CROSS_ORGANIZATION : null);
    }

    isValid() {
        return this.state.crossOrganisation !== null;
    }

    render() {
        const warning = this.props.possibleWarning && !this.isValid() ?  <Warning element=""/> : null;
        const error = warning && <div className='errorMessage'>Please select an option</div>;
        
        const toolTipIATU = "Select to which country the project is related (for global projects, select Switzerland)";
        
        return (
            <div>
                <Management/>
                <div className="audience-panel">
                    {warning}
                    Select the target audience for your site
                    { (this.props.isIATU || this.props.isIAPCP) && <InfoTooltip content={toolTipIATU} />}
                    <ChoiceGroup
                        options={[
                            {
                                key: false,
                                text: 'Specific country or region'
                            },
                            {
                                key: true,
                                text: 'Cross-organization'
                            }
                        ]}
                        onChange={this.onCrossOrganizationSelect}
                        selectedKey={this.isCrossOrganization()}
                        disabled = {this.props.geographyConfig.isDisabled || this.props.geographyConfig.isCrossOrgDisabled}
                    />
                    {error}
                </div>
                <br />
                {   
                    this.isCountryRegionOrganization() &&
                    <div>
                        <Geography possibleWarning={true} />
                    </div>
                }
                    
            </div>
        );
    }
}


const mapActionToProp = (dispatch) => ({
    setGeography: (element) => { dispatch(setGeoChoice(element)) },
    addOwner: (element) => { dispatch(addElement(ADD_OWNER, element)) },
    getUserManager: (userId) => dispatch(getUserManager(userId))
})

const mapStateToProps = state => ({
    selectedGeo: state.newSite.geography,
    possibleWarning: state.wizard.nextStepRequested,
    isIATU: state.newSite.isIATU,
    isIAPCP: state.newSite.isIAPCP,
    geographyConfig: (state.newSite.Template.config || {}).geographyConfig || {},
    owner: state.newSite.Owner,
    currentUser: state.user.currentUser,
})


export default connect(mapStateToProps, mapActionToProp)(CombineSteps)






// WEBPACK FOOTER //
// ./src/components/CreateSite/Step3/CombineSteps.js